export default "__VITE_PUBLIC_ASSET__ecdbf057__"